import { component } from "picoapp";
import { useProductView } from "../../Barba/Views/product";
import { TRANSITION_PRODUCT_VIEW_AFTER } from "../../Barba/Views/constants";
import { ITransitionData, Link, Trigger } from "@barba/core/dist/core/src/defs";
import { ComboBox } from "../../../../scripts/pdp";
import { ProductGallery } from "../ProductGallery/product-gallery";
import { Accordion } from "../../../../scripts/global/accordion";

import { TAB_SELECTED } from "../../Tab/oli-tabs";

export const isBarbaLink = (trigger: Trigger): trigger is Link => {
  return (trigger as Link) !== undefined;
};

export const productForm = component((node: HTMLElement) => {
  useProductView();
  const productGalleryContainer = document.querySelector<HTMLElement>(
    ".keen-slider-container"
  );
  const accordions = document.querySelectorAll<HTMLElement>("accordion-group");
  if (productGalleryContainer) {
    const productGallery = new ProductGallery(productGalleryContainer);
    productGallery._init();
  }

  accordions.forEach((accordion) => new Accordion(accordion));

  const quantityInput = node.querySelector<HTMLInputElement>(
    "[data-quantity-input]"
  );
  const incrementButton = node.querySelector<HTMLButtonElement>(
    "[data-quantity-add]"
  );
  const decrementButton = node.querySelector<HTMLButtonElement>(
    "[data-quantity-remove]"
  );
  const quantityIncrement = (e: MouseEvent) => {
    e.preventDefault();
    quantityInput.value = `${parseInt(quantityInput.value) + 1}`;
  };

  const quantityDecrement = (e: MouseEvent) => {
    e.preventDefault();
    if (parseInt(quantityInput.value) > 1) {
      quantityInput.value = `${parseInt(quantityInput.value) - 1}`;
    } else {
      quantityInput.value = "1";
    }
  };

  incrementButton?.addEventListener("click", quantityIncrement);
  decrementButton?.addEventListener("click", quantityDecrement);

  // Legacy JS Component - ComboBox
  const comboBox = new ComboBox();
  comboBox._init();

  const submitGAEvents = (trigger: Link) => {
    if (window.gtag) {
      const productTitle = trigger.dataset.title;
      window.gtag("event", "Flavor Selection", {
        event_detail: productTitle,
      });
    }
  };

  window.addEventListener(TAB_SELECTED, ({ detail }) => {
    if (window.gtag) {
      window.gtag("event", "Product Group Selection", {
        event_detail:
          detail.tab.dataset.collectionTitle || detail.tab.textContent.trim(),
      });
    }
  });

  window.addEventListener(
    TRANSITION_PRODUCT_VIEW_AFTER,
    ({ detail }: CustomEvent<ITransitionData>) => {
      if (isBarbaLink(detail.trigger)) {
        detail.trigger.focus();

        submitGAEvents(detail.trigger);
      }
    }
  );
});
